import React from 'react';
import type { FC } from 'react';
import { InitializingState } from './InitializingState.js';
import { ReadyState } from './ReadyState.js';

export const DevCommand: FC = () => {
  return (
    <InitializingState>
      <ReadyState />
    </InitializingState>
  );
};
